import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/wallet";

export const CreditAmount = async (values) => {
    return await axiosInstance(options).post(`${path}/credit-amount`, values)
}

export const listTransactions = async (values) => {
  return await axiosInstance(options).post(`${path}/list-transactions`, values);
}